/** Phase: 업체 대시보드 전용 알림함(/business-notifications) — ko/en/vi/ru
 * 소비자 알림(push_notifications, /notifications)과 완전히 분리된 업체용 화면.
 * business_notifications 테이블은 아직 아무 데서도 insert하지 않아 항상 비어있으므로
 * useBusinessActionBadge와 동일한 실데이터(예약 대기/신규 주문/미확인 문의)를 그 자리에서 조립해 보여준다.
 */

function pick(tuple, i) {
  return tuple[i];
}

function buildLang(langIndex) {
  const businessNotifications = {
    title: ['알림', 'Notifications', 'Thông báo', 'Уведомления'],
    empty: [
      '확인할 알림이 없어요.',
      'No notifications to check right now.',
      'Không có thông báo nào cần xem.',
      'Пока нет уведомлений для проверки.',
    ],
    emptySub: [
      '새 예약 요청, 신규 주문, 문의가 오면 여기에 뜹니다.',
      'New booking requests, orders, and inquiries will show up here.',
      'Yêu cầu đặt chỗ, đơn hàng mới và câu hỏi sẽ hiện ở đây.',
      'Здесь появятся новые запросы на бронирование, заказы и обращения.',
    ],
    loadError: [
      '알림을 불러오지 못했어요.',
      'Could not load notifications.',
      'Không tải được thông báo.',
      'Не удалось загрузить уведомления.',
    ],
    booking: {
      title: ['새 예약 요청', 'New booking request', 'Yêu cầu đặt chỗ mới', 'Новый запрос на бронирование'],
      meta: [
        '{guest} · {count} · {date}',
        '{guest} · {count} · {date}',
        '{guest} · {count} · {date}',
        '{guest} · {count} · {date}',
      ],
    },
    order: {
      title: ['새 주문', 'New order', 'Đơn hàng mới', 'Новый заказ'],
      meta: ['{item} · {amount}', '{item} · {amount}', '{item} · {amount}', '{item} · {amount}'],
    },
    inquiry: {
      title: ['새 문의', 'New inquiry', 'Câu hỏi mới', 'Новое обращение'],
    },
    businessFallback: ['업체', 'Business', 'Doanh nghiệp', 'Заведение'],
  };

  function walk(node) {
    if (Array.isArray(node)) return pick(node, langIndex);
    const out = {};
    Object.entries(node).forEach(([k, v]) => {
      out[k] = walk(v);
    });
    return out;
  }

  return { businessNotifications: walk(businessNotifications) };
}

export const phaseBizNotifKo = buildLang(0);
export const phaseBizNotifEn = buildLang(1);
export const phaseBizNotifVi = buildLang(2);
export const phaseBizNotifRu = buildLang(3);
